import {Injectable} from '@angular/core';
import {DefaultDataServiceConfig, Logger} from '@ngrx/data';
import {HttpClient} from '@angular/common/http';
import {AbstractDataServiceV2} from "../../../../../../../../core/service/v2/dataservice/abstractDataServiceV2";
import {CustomizeHttpUrlGenerator} from "../../../../../../../../../store/core/url/customizeHttpUrlGenerator";
import {TreatmentJourneyConverter} from "../../../api/entity/treatmentJourney.converter";
import {TreatmentJourneyModel} from "../../../api/entity/treatmentJourney.model";

@Injectable({
    providedIn: 'root'
})
export class TreatmentJourneyDataService extends AbstractDataServiceV2<TreatmentJourneyModel, TreatmentJourneyConverter> {
    constructor(http: HttpClient,
                httpUrlGenerator: CustomizeHttpUrlGenerator,
                logger: Logger,
                config: DefaultDataServiceConfig,
                converter: TreatmentJourneyConverter) {
        super('TreatmentJourney', http, httpUrlGenerator, logger, config, converter);
    }
}
